module.exports = __webpack_public_path__ + "img/card_orange.266e6b47.jpg";